import http from "./http.js";

const post = http.post;
const get = http.get;

export const commonApi = {
  /**获取验证码(用于忘记密码、注册获取手机短信验证码使用)
   * codeType:REGISTER 注册的短信验证码、FORGET_PASSWORD 忘记密码的短信验证码 （REGISTER,FORGET_PASSWORD,BIND,LOGIN）
   */
  sendCode: post("/verification/send/code")
};

export const loginApi = {
  /** 获取账套列表 */
  getUserList: post("/userInfo/userList"),
  /** 用户登录接口 */
  login: post("/token/login"),
  /** 用户忘记密码 */
  changePass: post("/token/change/pass"),
  /** 用户注册接口 */
  register: post("/token/register"),
  /** 获取APP扫码登录二维码信息 */
  getLoginQr: post("/token/qr"),
  /** 轮询获取二维码扫码结果 */
  qrLoop: get("/token/loop"),
  /** 微信扫码登录 */
  wxLogin: post("/login/pcWXLogin"),
  /** 根据电话号码获取PC_URL */
  getPcURL: get("/token/pc/url"),
  /** 获取租户账套产品信息 */
  getProInfo: get("/token/product"),
  /** 新版登录-涵盖：
   * TEL_LOGIN:一键登录
   * TEL_MSG_LOGIN:手机验证码登录
   * PWD_LOGIN:用户名密码登录
   * WX：微信登录
   * APPLE：苹果登录
   * QRCODE：扫码
   */
  authCodeLogin: post("/login/authCodeLogin"),
  /** 新版登录 */
  newLogin: post("/token/newlogin"),
  /** 获取行业列表 */
  getTradeList: get("/login/getTradeTypeList"),
  /** 创建企业 */
  createTenant: post("/token/createtenant"),
  /** 获取企业列表 */
  getTenantList: get("/login/getUserList"),
  /** PC端微信绑定并登录 */
  bindWxLogin: post("/login/pc/bind/wxLogin"),
  /** 检查账套是否提示升级 */
  checkUpgrade: get("/token/checkUpgrade"),
  /** 系统版本升级 */
  upgrade: get("/token/loginUpVersion"),
  /** 获取语言列表 */
  getLanguageList: get("/language/list"),
}



// WEBPACK FOOTER //
// ./src/api/api.js